(() => {
  customElements.whenDefined('predictive-search').then(() => {
    const Component = customElements.get('predictive-search');

    if (Component.prototype.titlePriorityInstalled) return;
    Component.prototype.titlePriorityInstalled = true;

    const productKey = (card) => {
      const link = Array.from(card.querySelectorAll('a[href]'))
        .find((anchor) => anchor.href.includes('/products/'));

      if (!link) return null;

      const path = new URL(link.href, window.location.origin).pathname;
      return path.split('/products/')[1]?.split('/')[0] || null;
    };

    Component.prototype.getSearchResults = function (searchTerm) {
      clearTimeout(this.titleSearchTimer);

      this.titleSearchController?.abort();

      const requestId = (this.titleSearchRequestId || 0) + 1;
      this.titleSearchRequestId = requestId;

      const isCurrent = () =>
        this.titleSearchRequestId === requestId &&
        this.getQuery() === searchTerm;

      const cacheKey = `title-priority-v1:${searchTerm}`;

      if (Array.from(searchTerm.trim()).length < 3) {
        this.close();
        this.removeAttribute('results');
        this.predictiveSearchResults.innerHTML = '';
        return;
      }

      this.setLiveRegionLoadingState();

      if (this.cachedResults[cacheKey]) {
        this.renderSearchResults(this.cachedResults[cacheKey]);
        return;
      }

      this.titleSearchTimer = setTimeout(async () => {
        if (!isCurrent()) return;

        const controller = new AbortController();
        this.titleSearchController = controller;

        const predictiveURL = new URL(
          theme.routes.predictive_search_url,
          window.location.origin
        );

        predictiveURL.searchParams.set('q', searchTerm);
        predictiveURL.searchParams.set('resources[limit]', '10');
        predictiveURL.searchParams.set('resources[limit_scope]', 'each');
        predictiveURL.searchParams.set('section_id', 'predictive-search');

        const searchURL = new URL(predictiveURL);
        searchURL.pathname = searchURL.pathname.replace(
          /\/suggest(?:\.json)?\/?$/,
          ''
        );
        searchURL.search = '';
        searchURL.searchParams.set('q', searchTerm);
        searchURL.searchParams.set('type', 'product');
        searchURL.searchParams.set('options[prefix]', 'last');
        searchURL.searchParams.set('section_id', 'search-title-check');

        const loadHTML = async (url) => {
          const response = await fetch(url, {
            signal: controller.signal
          });

          if (!response.ok) {
            throw new Error(`Búsqueda: ${response.status}`);
          }

          return new DOMParser().parseFromString(
            await response.text(),
            'text/html'
          );
        };

        try {
          const [predictiveResult, titleResult] =
            await Promise.allSettled([
              loadHTML(predictiveURL),
              loadHTML(searchURL)
            ]);

          if (!isCurrent()) return;

          if (predictiveResult.status !== 'fulfilled') {
            throw predictiveResult.reason;
          }

          const predictiveDocument = predictiveResult.value;
          const root = predictiveDocument.querySelector(
            '#shopify-section-predictive-search'
          );

          if (!root) {
            throw new Error('No se encontró la sección predictiva.');
          }

          let cacheable = false;

          if (titleResult.status === 'fulfilled') {
            const titleResponse = titleResult.value.querySelector(
              '[data-title-search-response]'
            );
            const titleColumn = titleResponse?.querySelector(
              '[data-title-product-column]'
            );
            const titleGrid = titleColumn?.querySelector('.grid');

            if (titleResponse && titleGrid) {
              cacheable = true;

              if (Number(titleResponse.dataset.totalPages) > 1) {
                console.warn(
                  'Prioridad por título: solo se revisó la primera página de hasta 250 resultados.'
                );
              }

              if (titleGrid.children.length > 0) {
                const originalList = root.querySelector(
                  '[data-search-results]'
                );
                const originalColumn = originalList?.closest(
                  '.predictive-search__column'
                );
                const originalGrid = originalList?.querySelector('.grid');

                const seen = new Set();

                Array.from(titleGrid.children).forEach((card) => {
                  const key = productKey(card);
                  if (key) seen.add(key);
                });

                if (originalGrid) {
                  for (const card of Array.from(originalGrid.children)) {
                    if (titleGrid.children.length >= 10) break;

                    const key = productKey(card);
                    if (!key || seen.has(key)) continue;

                    seen.add(key);
                    titleGrid.appendChild(card.cloneNode(true));
                  }
                }

                if (originalColumn) {
                  originalColumn.replaceWith(titleColumn);
                } else {
                  let layout = root.querySelector(
                    '[data-search-results-groups-wrapper]'
                  );

                  if (!layout) {
                    layout = predictiveDocument.createElement('div');
                    layout.className =
                      'predictive-search__layout predictive-search__layout--no-suggestions';
                    layout.setAttribute(
                      'data-search-results-groups-wrapper',
                      ''
                    );

                    const actions = root.querySelector(
                      '.predictive-search__actions'
                    );

                    actions.before(layout);
                  }

                  layout.classList.remove(
                    'predictive-search__layout--no-products'
                  );
                  layout.appendChild(titleColumn);
                }

                // Evitar IDs repetidos al combinar tarjetas.
                titleGrid.querySelectorAll('[id]').forEach((element, index) => {
                  element.id = `title-search-card-${index + 1}`;
                });

                const liveRegion = root.querySelector(
                  '[data-predictive-search-live-region-count-value]'
                );

                if (liveRegion) {
                  const otherOptions = Array.from(
                    root.querySelectorAll('[role="option"]')
                  ).filter((element) =>
                    !titleColumn.contains(element) &&
                    !element.closest('.predictive-search__actions')
                  ).length;

                  liveRegion.textContent =
                    `${titleGrid.children.length} productos mostrados` +
                    ` y ${otherOptions} opciones adicionales.`;
                }
              }
            }
          }

          const markup = root.innerHTML;

          if (!isCurrent()) return;

          if (cacheable) {
            this.allPredictiveSearchInstances.forEach((instance) => {
              instance.cachedResults[cacheKey] = markup;
            });
          }

          this.renderSearchResults(markup);
        } catch (error) {
          if (error.name === 'AbortError' || !isCurrent()) return;

          this.close();
          console.error('Error en búsqueda por título:', error);
        }
      }, 300);
    };
  });
})();
